// extracted by mini-css-extract-plugin
export default {"card":"card_card__7D0pj","content":"card_content__YeLpz","pAfter":"card_pAfter__pSwuE","skillafter":"card_skillafter__Z9rWy","imgbox":"card_imgbox__VxhJy"};